export const PARSE_SPREADSHEET_DATA = 'admin/whitelist/PARSE_SPREADSHEET_DATA'
export const UPLOAD_SPREADSHEET_DATA = 'admin/whitelist/UPLOAD_SPREADSHEET_DATA'

export const SET_SPREADSHEET_DATA = 'admin/whitelist/SET_SPREADSHEET_DATA'
export const SET_VALIDATION_DATA = 'admin/whitelist/SET_VALIDATION_DATA'

export const SET_LAST_SUCCESS_COUNT = 'admin/whitelist/SET_LAST_SUCCESS_COUNT'

export const SET_UPLOAD_STATUS = 'admin/whitelist/SET_UPLOAD_STATUS'
export const SET_RESULT_STATUS = 'admin/whitelist/SET_RESULT_STATUS'

const createAction = type => payload => ({ type, payload })
const createClearDataAction = (type, payload) => () => ({ type, payload })

export const parseSpreadsheetData = createAction(PARSE_SPREADSHEET_DATA)

export const uploadSpreadsheetData = createAction(UPLOAD_SPREADSHEET_DATA)

export const setSpreadsheetData = createAction(SET_SPREADSHEET_DATA)
export const setValidationData = createAction(SET_VALIDATION_DATA)
export const clearSpreadsheetData = createClearDataAction(SET_SPREADSHEET_DATA, [])
export const clearValidationData = createClearDataAction(SET_VALIDATION_DATA, {})

export const setLastSuccessCount = createAction(SET_LAST_SUCCESS_COUNT)

export const setUploadStatus = createAction(SET_UPLOAD_STATUS)
export const setResultStatus = createAction(SET_RESULT_STATUS)
